// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d612185c","389":"4b8a2a33","455":"8abfe923","977":"450e984a"}[chunkId] + ".chunk.js";
};